<template>
  <div>
    <RentalParentBar type="meterElec" />
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="d-flex justify-center my-4" flat>
          <v-row class="mx-0">
            <v-col cols="12" class="d-flex justify-center">
              <v-row class="bg-white">
                <v-col cols="4" class="d-flex gap-10 text-start pt-4 pl-4 align-center">
                  <h1><b>{{ $t('meter.record_elec_meter') }}</b></h1>
                  <div style="max-width: 200px;">
                    <SelectMonthYear :isDisabled="isLoading" @onSelect="onSelectMonthYear" />
                  </div>
                </v-col>
                <v-col cols="8" class="d-flex align-center text-end">
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        @click="exportExcel()"
                        class="blue white--text mx-1"
                        :disabled="isLoading || isLoadingExportMeter"
                      >
                        <v-icon class="me-2">mdi-file-excel</v-icon>Export Excel
                      </v-btn>
                      <v-btn
                        @click="exportDigitalMeterData()"
                        class="blue white--text mx-1"
                        :loading="isLoading || isLoadingDigitalMeter || isLoadingExportDigitalMeter"
                        :disabled="isLoading || isLoadingExportMeter || isLoadingExportDigitalMeter"
                        v-show="isCreativeAndData"
                      >
                        <v-icon class="me-2">mdi-cloud-arrow-up</v-icon>
                        <template v-slot:loader>
                          <v-progress-circular indeterminate size="16" width="2" class="me-2"></v-progress-circular>
                          <span>{{ $t('is_loading') }}...</span>
                        </template>
                        <span>EXPORT {{ $t('meter.electricity_digital_meter_report') }}</span>
                      </v-btn>
                      <v-btn
                        v-if="isDigitalMeter"
                        @click="getDigitalMeterUnit()"
                        class="blue white--text mx-1"
                        :loading="isLoading || isLoadingDigitalMeter"
                        :disabled="isLoading || isLoadingDigitalMeter"
                      >
                        <v-icon class="me-2">mdi-cloud-download</v-icon>Export Digital Meter
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="d-flex justify-center my-10" v-if="isLoading">
              <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
            </v-col>
            <v-col cols="12" v-else class="px-0">
              <v-simple-table class="table-cut-text">
                <template>
                  <thead class="table-item header">
                    <tr>
                      <th
                        width="5%"
                        class="text-center"
                        @click="currentSort == 'asc' ? currentSort = 'desc' : currentSort = 'asc'"
                        style="cursor: pointer;"
                      >
                        {{ $t('bill.order') }}
                        <v-icon v-if="currentSort == 'asc'">mdi-arrow-up</v-icon>
                        <v-icon v-if="currentSort == 'desc'">mdi-arrow-down</v-icon>
                      </th>
                      <th width="10%" class="text-center">{{ $t('area.space') }}</th>
                      <th class="text-center">{{ $t('market.marchant_name') }}</th>
                      <th width="10%" class="text-center">{{ $t('meter.meter_name') }}</th>
                      <th width="8%" class="text-center">{{ $t('other') }}</th>
                      <th width="17%" class="text-center">
                        {{ $t('meter.meter_month_number') }}
                        <br />
                        ( {{
                        $moment({
                        days: 15,
                        month: selectedMonthYear.month - 1,
                        year: selectedMonthYear.year,
                        }).subtract(1, 'months').format("MMMM/YYYY")
                        }} )
                      </th>
                      <th width="17%" class="text-center">
                        {{ $t('meter.meter_month_number') }}
                        <br />
                        ( {{ selectedMonthYear.name }} )
                      </th>
                      <th width="17%" class="text-center">{{ $t('meter.unit') }}</th>
                      <th width="5%" class="text-center" v-if="isDigitalMeter"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                      </td>
                      <td>
                        <v-text-field class="input-filter" v-model="filterData.areaName" type="text" :placeholder="$t('area.space')" outlined dense hide-details />
                      </td>
                      <td>
                        <v-text-field class="input-filter" v-model="filterData.customerName" type="text" :placeholder="$t('market.marchant_name')" outlined dense hide-details />
                      </td>
                      <td>
                        <v-text-field class="input-filter" v-model="filterData.meterName" type="text" :placeholder="$t('meter.meter_name')" outlined dense hide-details />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <template v-for="(meter,index) in orderHashMeters" v-if="!isRefLoading">
                      <tr class="text-center">
                        <td
                          :rowspan="
                            meter.subMeters ? meter.subMeters.length + 1 : ''
                          "
                        >{{ index+1 }}</td>
                        <td
                          :rowspan="
                            meter.subMeters ? meter.subMeters.length + 1 : ''
                          "
                        >{{ meter.mainMeter.area.name }}</td>
                        <td
                          class="cut-text"
                          :rowspan="
                            meter.subMeters ? meter.subMeters.length + 1 : ''
                          "
                        >
                          <template
                            v-if="meter.mainMeter.area.contract && meter.mainMeter.area.contract.billingData"
                          >{{ meter.mainMeter.area.contract.billingData.name }}</template>
                        </td>
                      </tr>
                      <template v-for="subMeter in meter.subMeters">
                        <tr class="text-center">
                          <td>{{ subMeter.meterName || $t('additional') }}</td>
                          <td>
                            <v-menu top :offset-y="true">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark v-bind="attrs" v-on="on" icon>
                                  <v-icon>mdi-menu</v-icon>
                                </v-btn>
                              </template>

                              <v-list>
                                <v-list-item @click="settingRecord(subMeter)">
                                  <v-list-item-title>{{ $t('meter.full_meter') }} / {{ $t('meter.change_meter') }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                          <td>
                            <template
                              v-if="hashMetersUnit[subMeter.objectId].isChanged"
                            >({{ hashMetersUnit[subMeter.objectId].oldUnit }}-{{hashMetersUnit[subMeter.objectId].previousUnit || 0}}) {{ hashMetersUnit[subMeter.objectId].newUnit }}</template>
                            <template
                              v-else
                            >{{ hashMetersUnit[subMeter.objectId].previousUnit || 0 }}</template>
                            <v-tooltip
                              top
                              v-if="hashMetersUnit[subMeter.objectId].isExceed || hashMetersUnit[subMeter.objectId].isChanged"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="warning"
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                >mdi-alert-circle</v-icon>
                              </template>
                              <span v-if="hashMetersUnit[subMeter.objectId].isExceed">{{ $t('meter.full_meter') }}</span>
                              <span v-else>{{ $t('meter.change_meter') }}</span>
                            </v-tooltip>
                            <div class="d-flex justify-center">
                              <v-checkbox
                                class="d-flex justify-center mt-1"
                                v-if="hashMetersUnit[subMeter.objectId].isCanSetStartMeterData && hashMetersUnit[subMeter.objectId].startMeterData"
                                v-model="hashMetersUnit[subMeter.objectId].startMeterData.isUsed"
                                @change="updatePreviousUnit(subMeter.objectId)"
                                hide-details
                                :label="`${$t('market.use_number_to_stall')} (${hashMetersUnit[subMeter.objectId].startMeterData.unit})`"
                              />
                            </div>
                          </td>
                          <td class="py-1">
                            <v-text-field
                              background-color="rgb(255, 0, 0, 0.3)"
                              solo
                              hide-details="auto"
                              class="input-center input-disable-appearance"
                              type="text"
                              style="opacity: 0.75"
                              ref="inputUnit"
                              :id="`input-unit-${subMeter.objectId}`"
                              @keyup="onKeyUp"
                              @change="onChangeUnit($event, subMeter.objectId)"
                              v-model="hashMetersUnit[subMeter.objectId].unit"
                            ></v-text-field>
                            <small
                              v-if="subMeter.digitalMeterData && hashMetersUnit[subMeter.objectId].dateTime"
                              :class="hashMetersUnit[subMeter.objectId].isErrorDigitalMeterDateTime ? 'red--text' : ''"
                            >{{ $t('updatedate') }} {{ $moment(hashMetersUnit[subMeter.objectId].dateTime).format('lll') }}</small>
                          </td>
                          <template v-if="hashMetersUnit[subMeter.objectId].isExceed">
                            <td
                              :class="parseFloat(hashMetersUnit[subMeter.objectId].unit) - (hashMetersUnit[subMeter.objectId].previousUnit || 0) + hashMetersUnit[subMeter.objectId].unitLimit + 1 < 0 ? 'unit-error' : ''"
                            >{{ parseFloat(hashMetersUnit[subMeter.objectId].unit) - (hashMetersUnit[subMeter.objectId].previousUnit || 0) + hashMetersUnit[subMeter.objectId].unitLimit + 1 | arabic }}</td>
                          </template>
                          <template v-else-if="hashMetersUnit[subMeter.objectId].isChanged">
                            <td
                              :class="hashMetersUnit[subMeter.objectId].oldUnit - hashMetersUnit[subMeter.objectId].newUnit - (hashMetersUnit[subMeter.objectId].previousUnit || 0) + parseFloat(hashMetersUnit[subMeter.objectId].unit)  < 0 ? 'unit-error' : ''"
                            >{{ hashMetersUnit[subMeter.objectId].oldUnit - hashMetersUnit[subMeter.objectId].newUnit - (hashMetersUnit[subMeter.objectId].previousUnit || 0) + parseFloat(hashMetersUnit[subMeter.objectId].unit) | arabic }}</td>
                          </template>
                          <template v-else>
                            <td
                              :class="parseFloat(hashMetersUnit[subMeter.objectId].unit) - (hashMetersUnit[subMeter.objectId].previousUnit || 0) < 0 ? 'unit-error' : ''"
                            >{{ parseFloat(hashMetersUnit[subMeter.objectId].unit) - (hashMetersUnit[subMeter.objectId].previousUnit || 0) | arabic }}</td>
                          </template>
                          <td v-if="isDigitalMeter">
                            <v-btn
                              v-if="isMeterDateDialogCanRead(subMeter)"
                              :disabled="isLoadingDigitalMeter"
                              icon
                              @click="getDigitalMeterUnit(subMeter)"
                            >
                              <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                large
                color="primary"
                elevation="2"
                style="opacity: 0.75"
                class="px-5"
                @click="bfSaveMeters()"
                :disabled="isLoading || isLoadingExportMeter || isLoadingDialog"
              >{{ $t('save') }}</v-btn>
            </v-col>
          </v-row>
          <v-snackbar v-model="isError" color="error" top>
            <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
          </v-snackbar>
          <v-snackbar v-model="isSuccess" color="success" top>
            <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
          </v-snackbar>
          <v-snackbar v-model="isReadSuccess" color="success" top>
            <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('readsuccess') }}
          </v-snackbar>
        </div>
      </template>
    </layout>
    <LoadingPercentDialog
      v-model="isLoadingDialog"
      :final="loadingFinal"
      :initial="loadingInitial"
    />
    <MeterRecordSetting
      v-model="isSettingRecordDialog"
      :data="tempMeter && hashMetersUnit[tempMeter.objectId] ? hashMetersUnit[tempMeter.objectId] : null"
      @onSuccess="onMeterRecordSetting"
    />
    <confirm-dialog
      :title="`${$t('meter.elec_meter_title')}`"
      :description="`${$t('validate.have_negative_unit_can_not_send_bill_want_to_save')}`"
      @onOk="saveMeters()"
      :confirmColor="`error`"
      v-model="isErrorMeter"
      :disabled="isLoading || isLoadingExportMeter || isLoadingDialog"
    ></confirm-dialog>
    <DigitalMeterDateDialog
      v-model="isMeterDateDialog"
      :isMainLoading="isLoading || isLoadingDigitalMeter"
      :digitalMeterDataList="tempDigitalMeterDataList"
      @onSuccess="onDigitalMeterDate"
    />
  </div>
</template>
<script>
import SelectMonthYear from "@/components/SelectMonthYear.component.vue";
import { Meter, MeterRecord, Market, DigitalMeter } from "../../classes";
import ParentBar from "@/components/ParentBar.vue";
import RentalParentBar from "@/components/RentalParentBar.component";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component";
import Layout from "@/components/Layout.vue";
import MeterRecordSetting from "@/components/MeterRecordSetting.component.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { ExportMeter } from "../../exports";
import DigitalMeterDateDialog from "@/components/DigitalMeterDateDialog.vue";
import { ExportDigitalMeterReport } from "../../exports/ExportDigitalMeterReport";
export default {
  data() {
    return {
      marketId: null,
      selectedMonthYear: null,
      type: "elec",
      meters: {
        water: [],
        elec: []
      },
      isError: false,
      isSuccess: false,
      isLoading: true,
      hashMeters: {},
      hashMetersUnit: {},
      isLoadingDialog: false,
      loadingFinal: 0,
      loadingInitial: 0,
      isLoadingExportMeter: false,
      isLoadingExportDigitalMeter: false,
      isDigitalMeter: false,
      project: null,
      market: null,
      hashDigitalMetersUnit: null,
      meters: null,
      isReadSuccess: false,
      isLoadingDigitalMeter: false,
      currentSort: "asc",
      isSettingRecordDialog: false,
      tempMeter: null,
      isErrorMeter: false,
      isMeterDateDialog: false,
      digitalMeterDataList: null,
      tempDigitalMeterDataList: null,
      isRefLoading: false,
      filterData: {
        areaName: null,
        customerName: null,
        meterName: null,
      }
    };
  },
  components: {
    SelectMonthYear,
    ParentBar,
    RentalParentBar,
    LoadingPercentDialog,
    Layout,
    MeterRecordSetting,
    ConfirmDialog,
    DigitalMeterDateDialog
  },
  computed: {
    hourOptions(){
      let arr = []
      for(let i = 0; i <= 23; i++){
        arr.push(this.$helper.formatNumberLength(i, 2))
      }
      return arr
    },
    minuteOptions(){
      let arr = []
      for(let i = 0; i <= 59; i++){
        arr.push(this.$helper.formatNumberLength(i, 2))
      }
      return arr
    },
    filterMeters() {
      let tempHash = {};
      if (this.meters?.length) {
        for (let meter of this.meters.sort((a, b) => b.isMain - a.isMain)) {
          if (meter?.area?.objectId) {
            if (!tempHash[meter.area.objectId]) {
              tempHash[meter.area.objectId] = {
                mainMeter: {},
                subMeters: []
              };
            }
            let data = {
              ...meter,
              areaName: meter.area.name,
              customerName: meter.area.contract ? meter.area.contract.billingData?.name : "",
              meterName: meter.name ? meter.name : meter.isMain ? this.$t('main') : this.$t('additional'),
            }

            if (meter.isMain) {
              tempHash[meter.area.objectId].mainMeter = data;
            }
            if (this.filterData.meterName) {
              if (data.meterName && data.meterName.toLowerCase().includes(this.filterData.meterName.toLowerCase())) {
                tempHash[meter.area.objectId].subMeters.push(data);
              }
            } else {
              tempHash[meter.area.objectId].subMeters.push(data);
            }
          }
        }
      }
      let arr = []
      for (let key in tempHash) {
        if (tempHash[key].subMeters.length) {
          arr.push(tempHash[key])
        }
      }
      if (this.filterData.areaName) {
        arr = arr.filter(item => item.mainMeter.area.name.toLowerCase().includes(this.filterData.areaName.toLowerCase()))
      }
      if (this.filterData.customerName) {
        arr = arr.filter(item => item.mainMeter.area.contract?.billingData?.name?.toLowerCase().includes(this.filterData.customerName.toLowerCase()))
      }
      return arr;
    },
    orderHashMeters() {
      let modifier = 1;
      if (this.currentSort === "desc") modifier = -1;
      return this.filterMeters.sort(function(a, b) {
        if (a.mainMeter.area.order < b.mainMeter.area.order) {
          return -1 * modifier;
        }
        if (a.mainMeter.area.order > b.mainMeter.area.order) {
          return 1 * modifier;
        }
        return 0;
      });
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    isCreativeAndData() {
      return this.digitalMeterDataList?.some(item => 
        item.partner === "creative_power" && item.type !== "prepaid"
      ) ?? false;
    }
  },
  async created() {
    this.marketId = this.$route.params.marketId;
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.hashMeters = {};
      this.hashMetersUnit = {};
      try {
        if (this.admin) {
          this.project = this.admin.project;
          this.market = this.admin.market;
        }
        if (this.employee) {
          this.project = this.employee.project;
          this.market = this.employee.market;
        }

        this.digitalMeterDataList = this.market.digitalMeterData?.filter(d => d.type != "prepaid")
        if (this.digitalMeterDataList?.length) this.isDigitalMeter = true;

        this.meters = await Meter.getMeterByMarket(this.marketId, "elec");

        if (this.meters?.length) {
          let tempHash = {};
          for (let meter of this.meters) {
            if (meter?.area?.objectId) {
              if (!this.hashMeters[meter.area.objectId]) {
                this.hashMeters[meter.area.objectId] = {
                  mainMeter: {},
                  subMeters: []
                };
              }

              if (meter.isMain)
                this.hashMeters[meter.area.objectId].mainMeter = meter;
              else 
                this.hashMeters[meter.area.objectId].subMeters.push(meter);

              if (!tempHash[meter.objectId]) {
                tempHash[meter.objectId] = {};
              }

              tempHash[meter.objectId].unit = 0;
              if (meter.area.contract) {
                if (meter.area.contract.startMeterData && meter.area.contract.startMeterData[meter.objectId]) {
                  tempHash[meter.objectId].contractId = meter.area.contract.objectId;
                  tempHash[meter.objectId].startMeterData = JSON.parse(JSON.stringify(meter.area.contract.startMeterData[meter.objectId]));
                  tempHash[meter.objectId].tempStartMeterData = JSON.parse(JSON.stringify(meter.area.contract.startMeterData[meter.objectId]));
                  tempHash[meter.objectId].isCanSetStartMeterData = !tempHash[meter.objectId].tempStartMeterData.isUsed;
                }
                tempHash[meter.objectId].chunkId = meter.area.contract.objectId;
              }else{
                tempHash[meter.objectId].chunkId = meter.objectId
              }
            }
          }
          this.hashMetersUnit = tempHash;
          await this.initMeterRecord();
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async initMeterRecord() {
      try {
        const result1 = await MeterRecord.getMeterRecordsByMarket(
          this.marketId,
          this.selectedMonthYear.month,
          this.selectedMonthYear.year
        );

        let previousMonth = this.selectedMonthYear.month - 1;
        let previousYear = this.selectedMonthYear.year;
        if (previousMonth == 0) {
          previousYear -= 1;
          previousMonth = 12;
        }

        const result2 = await MeterRecord.getMeterRecordsByMarket(
          this.marketId,
          previousMonth,
          previousYear
        );
        this.prepareMeterRecord(result1, result2);
      } catch (error) {
        throw error;
      }
    },
    prepareMeterRecord(nowRecords, previousRecords) {
      if (nowRecords?.length) {
        for (let record of nowRecords) {
          if (this.hashMetersUnit[record.meter.objectId]) {
            this.hashMetersUnit[record.meter.objectId].unit = record.unit || 0;
            this.hashMetersUnit[record.meter.objectId].old = record.unit || 0;
            this.hashMetersUnit[record.meter.objectId].isExceed = record.isExceed;
            this.hashMetersUnit[record.meter.objectId].unitLimit = record.unitLimit;
            this.hashMetersUnit[record.meter.objectId].isChanged = record.isChanged;
            this.hashMetersUnit[record.meter.objectId].oldUnit = record.oldUnit;
            this.hashMetersUnit[record.meter.objectId].newUnit = record.newUnit;
            if (record.contract) {
              this.hashMetersUnit[record.meter.objectId].isCanSetStartMeterData = true;
            }
            this.updatePreviousUnit(record.meter.objectId);
          }
        }
      }
      if (previousRecords?.length) {
        for (let record of previousRecords) {
          if (this.hashMetersUnit[record.meter.objectId]) {
            this.hashMetersUnit[record.meter.objectId].tempPreviousUnit = record.unit;
            this.hashMetersUnit[record.meter.objectId].previousUnit = record.unit;
            this.updatePreviousUnit(record.meter.objectId);
          }
        }
      }
    },
    async onSelectMonthYear(data) {
      this.selectedMonthYear = data;
      await this.initData();
    },
    onKeyUp($event) {
      if ($event.keyCode === 38 || $event.keyCode === 40) {
        let index = this.$refs.inputUnit.findIndex(
          d => d.computedId == $event.target.id
        );

        if ($event.keyCode === 38) {
          if (this.$refs.inputUnit[index - 1]) {
            this.$refs.inputUnit[index - 1].$el.querySelector("input").select();
          } else {
            this.$refs.inputUnit[index].$el.querySelector("input").select();
          }
        }

        if ($event.keyCode === 40) {
          if (this.$refs.inputUnit[index + 1]) {
            this.$refs.inputUnit[index + 1].$el.querySelector("input").select();
          } else {
            this.$refs.inputUnit[index].$el.querySelector("input").select();
          }
        }
      }
    },
    onChangeUnit(value, meterId){
      if(value?.toString()?.split(" ")?.length){
        let index = this.$refs.inputUnit.findIndex(
          d => d.id == `input-unit-${meterId}`
        );
        let arr = value.toString().split(" ")
        for(let [i, value] of arr.entries()){
          if(this.$refs.inputUnit[index + i])
            this.$refs.inputUnit[index + i].$emit('input', value ? parseFloat(value) : 0)
        }
      }
    },
    bfSaveMeters() {
      if (this.checkMeterError()) {
        this.isErrorMeter = true;
      } else {
        this.saveMeters();
      }
    },
    async saveMeters() {
      this.isLoadingDialog = true;
      this.loadingFinal = 0;
      // if (this.checkMeterError()) {
      //   this.isLoadingDialog = false;
      //   this.$toast.show({
      //     content: `เกิดข้อผิดพลาด : หน่วยที่ใช้ ไม่สามารถติดลบได้`,
      //     color: "error"
      //   });
      //   return;
      // }
      try {
        let postData = [];
        for (const [key, value] of Object.entries(this.hashMetersUnit)) {
          if (
            (this.hashMetersUnit[key].unit != this.hashMetersUnit[key].old &&
              !isNaN(parseFloat(value.unit))) ||
            this.hashMetersUnit[key].isUpdate ||
            (this.hashMetersUnit[key].startMeterData &&
              this.hashMetersUnit[key].startMeterData.isUsed !=
                this.hashMetersUnit[key].tempStartMeterData.isUsed)
          ) {
            let obj = {
              meterId: key,
              unit: parseFloat(value.unit),
              isExceed: value.isExceed,
              unitLimit: value.unitLimit,
              isChanged: value.isChanged,
              oldUnit: parseFloat(value.oldUnit),
              newUnit: parseFloat(value.newUnit),
              chunkId: value.chunkId
            };
            if (value.contractId && value.isCanSetStartMeterData) {
              obj.contractId = value.contractId;
              obj.isUseStartMeterData = value.startMeterData.isUsed;
            }
            postData.push(obj);
          }
        }
        let chunks = []
        do {
          let obj = postData.find(b => !b.isUse)
          if (obj) {
            let chunk = chunks.find(d => d.length < 5 && !d.find(b => b.chunkId == obj.chunkId))
            if (chunk) {
              obj.isUse = true
              chunk.push(obj)
            } else {
              obj.isUse = true
              chunk = [obj]
              chunks.push(chunk)
            }
          }
        } while (postData.find(b => !b.isUse))

        this.loadingInitial = chunks.length;
        for (let chunk of chunks) {
          let saveList = chunk.map(d => MeterRecord.saveMeterRecords(
            this.marketId,
            this.selectedMonthYear.month,
            this.selectedMonthYear.year,
            [d]
          ))
          let results = await Promise.all(saveList);
          for(let result of results){
            this.prepareMeterRecord(result.data);
          }
          this.loadingFinal++;
        }
        this.isLoadingDialog = false;
        this.isErrorMeter = false;
        this.isSuccess = true;
      } catch (error) {
        this.isLoadingDialog = false;
        this.isErrorMeter = false;
        this.isError = true;
      }
    },
    async exportExcel() {
      this.isLoadingExportMeter = true;
      try {
        let marketData = await Market.getMarketArea({ id: this.marketId });
        let hashArea = {};
        if (marketData.areas) {
          for (let area of marketData.areas) {
            hashArea[area.objectId] = area;
          }
        }
        await ExportMeter.exportMeterRecord(
          this.orderHashMeters,
          this.hashMetersUnit,
          hashArea,
          this.selectedMonthYear.month,
          this.selectedMonthYear.year,
          "elec"
        );
        this.isLoadingExportMeter = false;
      } catch (err) {
        this.isLoadingExportMeter = false;
        this.isError = true;
      }
    },
    async exportDigitalMeterData() {
      this.isLoadingExportDigitalMeter = true;
      try {
        let selectedMoment = this.$moment({
          year: this.selectedMonthYear.year,
          month: this.selectedMonthYear.month - 1,
          day: 1
        });
        
        let startDate = selectedMoment.clone().startOf('month').format('YYYY-MM-DD');
        let endDate = selectedMoment.clone().endOf('month').format('YYYY-MM-DD');

        let meters = []
        for (let data of this.orderHashMeters) {
          for (let meter of data.subMeters) {
            meters.push(meter)
          }
        }
        await ExportDigitalMeterReport.exportDigitalMeterReport(
          meters,
          startDate,
          endDate
        );
        this.isLoadingExportDigitalMeter = false;
      } catch (error) {
        this.isLoadingExportDigitalMeter = false;
        this.isError = true;
      } 
    },
    updatePreviousUnit(meterId) {
      if (
        this.hashMetersUnit[meterId].isCanSetStartMeterData &&
        this.hashMetersUnit[meterId].startMeterData &&
        this.hashMetersUnit[meterId].startMeterData.isUsed
      )
        this.hashMetersUnit[meterId].previousUnit = this.hashMetersUnit[meterId].startMeterData.unit;
      else
        this.hashMetersUnit[meterId].previousUnit = this.hashMetersUnit[meterId].tempPreviousUnit;
    },
    getDigitalMeterUnit(meter){
      this.tempMeter = null
      if(meter) {
        this.tempMeter = meter
        this.tempDigitalMeterDataList = [meter.digitalMeterData]
      } else {
        this.tempDigitalMeterDataList = this.digitalMeterDataList
      }
      this.isMeterDateDialog = true
    },
    onDigitalMeterDate(dateTime){
      if (this.tempMeter){
        this.loadDigitalMeterUnit(this.tempMeter, dateTime)
      } else {
        this.loadAllDigitalMeterUnit(dateTime)
      }
    },
    async loadDigitalMeterUnit(meter, dateTime) {
      this.isLoadingDigitalMeter = true;
      this.hashDigitalMetersUnit = {}
      try {
        let { partner, type, cust_id, meter_id } =  meter.digitalMeterData
        this.hashDigitalMetersUnit = await DigitalMeter.getLatestMeterData(
          partner,
          type,
          cust_id,
          meter_id,
          dateTime
        )

        if (this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]) {
          let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
          this.hashMetersUnit[meter.objectId].unit = data.unit || 0;
          this.hashMetersUnit[meter.objectId].dateTime = data.datetime;
          this.hashMetersUnit[meter.objectId].isErrorDigitalMeterDateTime = data.isOffline
        }

        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      } catch (err) {
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      }
    },
    async loadAllDigitalMeterUnit(dateTime) {
      this.isLoadingDigitalMeter = true;
      this.hashDigitalMetersUnit = {}
      try {
        let promises = []
        for (let data of this.digitalMeterDataList) {
          promises.push(
            DigitalMeter.getLatestMeterData(
              data.partner,
              data.type,
              data.cust_id,
              null,
              dateTime
            )
          )
        }
        let results = await Promise.all(promises)
        for (let result of results) {
          this.hashDigitalMetersUnit = {
            ...this.hashDigitalMetersUnit,
            ...result
          }
        }

        for (let meter of this.meters) {
          if (meter.digitalMeterData) {
            let cust_id = meter.digitalMeterData.cust_id;
            let meter_id = meter.digitalMeterData.meter_id;

            if (
              this.hashMetersUnit[meter.objectId] &&
              this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]
            ) {
              let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
              this.hashMetersUnit[meter.objectId].unit = data.unit || 0;
              this.hashMetersUnit[meter.objectId].dateTime = data.datetime;
              this.hashMetersUnit[meter.objectId].isErrorDigitalMeterDateTime = data.isOffline
            }
          }
        }
        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      } catch (err) {
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      }
    },
    checkMeterError() {
      let res = false;
      for (const [key, value] of Object.entries(this.hashMetersUnit)) {
        if (this.hashMetersUnit[key].isExceed) {
          if (
            parseFloat(this.hashMetersUnit[key].unit) -
              (this.hashMetersUnit[key].previousUnit || 0) +
              this.hashMetersUnit[key].unitLimit +
              1 <
            0
          ) {
            res = true;
            break;
          }
        } else if (this.hashMetersUnit[key].isChanged) {
          if (
            this.hashMetersUnit[key].oldUnit -
              this.hashMetersUnit[key].newUnit -
              (this.hashMetersUnit[key].previousUnit || 0) +
              parseFloat(this.hashMetersUnit[key].unit) <
            0
          ) {
            res = true;
            break;
          }
        } else {
          if (
            this.hashMetersUnit[key].unit <
            this.hashMetersUnit[key].previousUnit
          ) {
            res = true;
            break;
          }
        }
      }
      return res;
    },
    settingRecord(meter) {
      this.tempMeter = meter;
      this.isSettingRecordDialog = true;
    },
    onMeterRecordSetting(data) {
      this.isLoading = true;
      this.hashMetersUnit[this.tempMeter.objectId].isUpdate = true;
      if (data) {
        if (data.isExceed) {
          this.hashMetersUnit[this.tempMeter.objectId].isExceed = true;
          this.hashMetersUnit[this.tempMeter.objectId].unitLimit =
            data.unitLimit;

          this.hashMetersUnit[this.tempMeter.objectId].isChanged = false;
          this.hashMetersUnit[this.tempMeter.objectId].oldUnit = null;
          this.hashMetersUnit[this.tempMeter.objectId].newUnit = null;
        } else {
          this.hashMetersUnit[this.tempMeter.objectId].isChanged = true;
          this.hashMetersUnit[this.tempMeter.objectId].oldUnit = data.oldUnit;
          this.hashMetersUnit[this.tempMeter.objectId].newUnit = data.newUnit;

          this.hashMetersUnit[this.tempMeter.objectId].isExceed = false;
          this.hashMetersUnit[this.tempMeter.objectId].unitLimit = null;
        }
      } else {
        this.hashMetersUnit[this.tempMeter.objectId].isExceed = false;
        this.hashMetersUnit[this.tempMeter.objectId].unitLimit = null;

        this.hashMetersUnit[this.tempMeter.objectId].isChanged = false;
        this.hashMetersUnit[this.tempMeter.objectId].oldUnit = null;
        this.hashMetersUnit[this.tempMeter.objectId].newUnit = null;
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    },
    isMeterDateDialogCanRead(meter) {
      if (meter && meter.digitalMeterData && meter.digitalMeterData.meter_type != "prepaid") {
        return true
      }
    }
  },
  watch: {
    filterMeters: {
      handler() {
        this.isRefLoading = true
        this.$nextTick(() => {
          this.isRefLoading = false
        })
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">
.btn {
  transition: all 300s;
}
.btn-active {
  border: 2px solid rgb(0, 189, 0) !important;
  top: -3px;
}
.unit-error {
  background-color: rgba(255, 0, 0, 0.5);
  color: white;
}
.table-item.header {
  background-color: rgb(211, 216, 222);
  th {
    color: black !important;
    font-size: 16px;
    padding: 10px 0 !important;
  }
}
.cut-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.input-filter {
  zoom: 0.9;
}
</style>
